















import { Vue, Component, Prop } from 'vue-property-decorator';
import wave from '../../directives/wave';
import BaseIcon from '../base-icon/_base-icon.vue';

@Component({
  name: 'BaseChip',
  components: {
    BaseIcon,
  },
  directives: {
    wave,
  },
})
export default class BaseChip extends Vue {
  @Prop() label!: string;
  @Prop() isRemovable: boolean;

  handleRemove() {
    this.$emit('remove', this.label);
  }
}
